export class BranchCampaignsFilterEntity {
    id!: number
    branchId?: number
    page?: number
    limit?: number
}